import InfoModificationFormComponent from "../../../components/post-signature/InfoModificationFormComponent";


export default function REInfoModificationBloc() {

      return (
        <div className="">
          <InfoModificationFormComponent />
        </div>
      )
}